import { Menu, MenuItem } from '@blueprintjs/core';
import React, { Component } from 'react';


class MenuLateTrip extends Component {
  render() {
    return (
      <Menu>
        <MenuItem icon="confirm" text="Confirm Provider" id={'isOverlayConfirmProvider'} onClick={this.props.handleConfirmedMenuClick} />
        <MenuItem icon="delete" text="Remove Provider" id={'isDialogRemoveProvider'} onClick={this.props.handleConfirmedMenuClick} />
        <MenuItem icon="arrow-right" text="Emulate Events" id={'isOverlayEmulateEvents'} onClick={this.props.handleConfirmedMenuClick} />
        <MenuItem icon="mobile-phone" text="Send SMS" id={'isDialogSendSms'} onClick={this.props.handleConfirmedMenuClick} />
        <MenuItem icon="undo" text="Cancel Trip" id={'isOverlayConfirmTripCancellation'} onClick={this.props.handleConfirmedMenuClick} />
      </Menu>
    );
  }
}

export default MenuLateTrip;
